<template>
  <div id="app" :style="isListen ? listenBackground : backgroundStyle">
    <SiteHeader v-if="!isListen" />
    <main class="overlay-box" :class="{ 'is-listen': isListen }">
      <router-view />
    </main>
    <AudioPlayer v-if="!isListen" />
  </div>
</template>

<script>
import SiteHeader from './views/SiteHeader.vue'
import AudioPlayer from './views/AudioPlayer.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    AudioPlayer
  },
  computed: {
    isListen () {
      return this.$route.name === 'Listen'
    }
  },
  data () {
    return {
      backgroundStyle: {
        backgroundImage: 'url("/ol-bg.webp")',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        color: 'white'
      },
      // The /listen takeover paints its own full-screen navy background,
      // so we drop the site background image (and its fixed-attachment cost) here.
      listenBackground: {
        minHeight: '100vh',
        color: 'white'
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: sans-serif;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
main.overlay-box {
  flex: 1;
  padding: 2rem;
  padding-bottom: 5rem;
}
/* /listen is a standalone, edge-to-edge takeover: no header, no player, no inset. */
main.overlay-box.is-listen {
  padding: 0;
}
</style>
